import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import api from '../../services/api';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import LoadingBar from '../LoadingBar';
import { formataReal } from '../../utils/functions';

const swal = withReactContent(Swal)

export default function ModalPix(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [pixUrl, setPixUrl] = useState('');
    const [pixQrcode, setPixQrcode] = useState('');
    const [orderId, setOrderId] = useState('');
    const [mostrouMensagem, setMostrouMensagem] = useState(false);

    function confirmaModal() {

    }

    function fechaModal() {
        props.closeModal()
    }

    useEffect(() => {
        async function fetchData() {    
            setIsLoading(true)
            api.post('/pagarMe/pix', {total: props.total, parcelas: props.parcelas, cod_cliente: props.fk_cli}).then(r => {
                if (r.data == 'erro') {
                    return swal.fire('Falha ao gerar QR Code.', 'Tente novamente ou contate a administração', 'error').then(r=>{
                        fechaModal()
                    })
                }
                setOrderId(r.data.order_id)
                setPixUrl(r.data.pix_url)
                setPixQrcode(r.data.pix_qrcode)
                setIsLoading(false)
            }).catch(e => {
                
            })
        }
        if (props.showModal)
            fetchData()
    }, [props.showModal])

    function onFinish(type, data) {
        if (type === 'expirado') {
            api.post('/pagarMe/pix_expirado', data)
            return swal.fire('Qr code expirado!', 'Selecione novamente as parcelas e gere um novo qr code para o pagamento', 'error').then(r => {
                fechaModal()
            })
        } else if (type === 'pago' && !mostrouMensagem) {
            setMostrouMensagem(true)
            let auxValues = {
                ...data, 
                mensalidades: props.parcelas,
                pix_qrcode: pixQrcode,
                pix_qrcode_url: pixUrl
            }
            api.post('/pagarMe/pix_concluido', auxValues)
            swal.fire('Sucesso!', 'Agradecemos seu pagamento!', 'success').then(r => {
                pagamentoConcluido(data)
            })
        }
    }

    async function pagamentoConcluido(data) {
        setIsLoading(true)
        setIsLoading(false)
        setMostrouMensagem(false)
    }
  
    return (
        <Dialog aria-labelledby="simple-dialog-title" open={props.showModal} maxWidth={'lg'}>
            <div className="modalContent">

                <div style={{flex: 1}}>
                    <p style={{fontSize: 24, fontWeight: 'bold', marginTop: 15}}>
                        Total: {formataReal(Number(props.total))}
                    </p>

                </div>
                <div style={{flex: 1, justifyContent: 'center', alignItems: 'center', gap: 10, marginTop: 30}}>
                    <p>
                        Abra o seu APP e capture o QrCode para pagamento.
                    </p>
                    {
                        pixUrl && 

                        <img
                            style={{width: 250, height: 250, borderRadius: 10}}
                            source={{uri: pixUrl}}
                            alt='Qr Code'
                        />


                    }

                </div>

                <div style={{flex: 1, width: '100%', padding: 15, justifyContent: "flex-end", gap: 15}}>
                    <LoadingBar 
                        onFinish={onFinish}
                        counting={true}
                        duration={179000}
                        label='QR Code expira em '
                        orderId={orderId}
                    />
                </div> 
                

            </div>

            <div className="FrModalFooter">
                <div className="FrModalButtonsDiv">
                    <button onClick={fechaModal}> Sair </button>
                </div>
            </div>

        </Dialog>
    );
  }